import Paper from "../components/paper/Paper";
import styles from "./Eighth.module.css";

function Eighth({ papersRef }) {
  const papers = [
    {
      id: "1",
      title:
        "Towards Automating Domain-Specific Data Generation for Text-to-SQL: A Comprehensive Approach",
      source: "ACM Transactions on Software Engineering and Methodology",
      image: "/images/papers/paper1.png",
      citation:
        "@article{10.1145/3746226,\
          author = {Chafik, Salmane and Ezzini, Saad and Berrada, Ismail},\
          title = {Towards Automating Domain-Specific Data Generation for Text-to-SQL: A Comprehensive Approach},\
          year = {2026},\
          issue_date = {April 2026},\
          publisher = {Association for Computing Machinery},\
          address = {New York, NY, USA},\
          volume = {35},\
          number = {4},\
          issn = {1049-331X},\
          url = {https://doi.org/10.1145/3746226},\
          doi = {10.1145/3746226},\
          journal = {ACM Trans. Softw. Eng. Methodol.},\
          month = mar,\
          articleno = {96},\
          numpages = {27},\
          keywords = {Text-to-SQL, SQL-to-Text, Code Generation, Data Generation, Synthetic Data}\
          }",
      pdf: "https://dl.acm.org/doi/abs/10.1145/3746226",
    },
    {
      id: "2",
      title:
        "Enhancing security in text-to-SQL systems: A novel dataset and agent-based framework",
      source: "Natural Language Processing, Cambridge University Press",
      image: "/images/papers/paper2.png",
      citation:
        "@article{Chafik_Ezzini_Berrada_2025, \
        title={Enhancing security in text-to-SQL systems: A novel dataset and agent-based framework}, \
        volume={31}, \
        DOI={10.1017/nlp.2025.10008}, \
        number={6}, \
        journal={Natural Language Processing}, \
        author={Chafik, Salmane and Ezzini, Saad and Berrada, Ismail}, \
        year={2025}, \
        pages={1399–1422}}",
      pdf: "https://www.cambridge.org/core/journals/natural-language-processing/article/enhancing-security-in-texttosql-systems-a-novel-dataset-and-agentbased-framework/4D0F32A20438C18FD1F84DC7BD908F97",
    },
    {
      id: "3",
      title:
        "Dialect2SQL: A Novel Text-to-SQL Dataset for Arabic Dialects with a Focus on Moroccan Darija",
      source: "The 4th Workshop on Arabic Corpus Linguistics (WACL-4) | COLING'2025",
      image: "/images/papers/paper3.png",
      citation:
        "@article{chafik2025dialect2sql,\
            title={Dialect2SQL: A Novel Text-to-SQL Dataset for Arabic Dialects with a Focus on Moroccan Darija},\
            author={Chafik, Salmane and Ezzini, Saad and Berrada, Ismail},\
            journal={WACL-4},\
            pages={86},\
            year={2025}\
          }",
      pdf: "https://aclanthology.org/2025.wacl-1.10/",
    },
        {
      id: "4",
      title:
        "DarijaDB: Unlocking Text-to-SQL for Arabic Dialects",
      source: "ACM Transactions on Asian and Low-Resource Language Information Processing",
      image: "/images/papers/paper4.png",
      citation:
        "@article{10.1145/3787497,\
          author = {Chafik, Salmane and Ezzini, Saad and Berrada, Ismail},\
          title = {DarijaDB: Unlocking Text-to-SQL for Arabic Dialects},\
          year = {2026},\
          issue_date = {February 2026},\
          publisher = {Association for Computing Machinery},\
          address = {New York, NY, USA},\
          volume = {25},\
          number = {2},\
          issn = {2375-4699},\
          url = {https://doi.org/10.1145/3787497},\
          doi = {10.1145/3787497},\
          journal = {ACM Trans. Asian Low-Resour. Lang. Inf. Process.},\
          month = feb,\
          articleno = {12},\
          numpages = {19},\
          keywords = {Text-to-SQL, low resource language, Arabic dialects, darija}\
          }",
      pdf: "https://dl.acm.org/doi/epdf/10.1145/3787497",
    },
    
  ];

  return (
    <div ref={papersRef} className={styles.eighthsection}>
      <h1 className={styles.title}>04. Papers</h1>
      <div className={styles.papers}>
        {papers.map((paper) => (
          <Paper key={paper.id} paper={paper} />
        ))}
      </div>
    </div>
  );
}

export default Eighth;
